import axiosNextGen from '../../../config/axios-nextgen';

/**
 * BAC decline / not-offered reasons.
 *
 * Maintained from the next gen admin panel, so both gens read the same list - if this
 * stayed hardcoded here the two would drift apart the moment anyone edited it.
 *
 * @returns {Promise<Array<{bacReasonId: string, reasonType: 'Declined'|'NotOffered',
 *   description: string, requiresNotes: boolean, sortOrder: number, inactiveYn: boolean}>>}
 */
export async function getBacReasons() {
    // Active only - staff must never be offered a retired reason.
    const response = await axiosNextGen.get('/api/bac-reasons');
    return response.data;
}
